<div id="main" class="h-auto">
    <router-outlet />
</div>
